export default __webpack_public_path__ + "static/media/hanskleinTeaser.58489419.mp4";